module.exports = __webpack_public_path__ + "images/gavdos/apple-touch-icon.png";